import walk from './modules/walk';

export default {
	namespaced: true,
	state: () => ({}),
	mutation: {},
	actions: {},
	getters: {},
	modules: {
		walk,
	},
};



// WEBPACK FOOTER //
// ./src/store/Game/index.js